const missingParent = (child: string, parent: string) =>
  `${child} must be a child of ${parent}.`;

export { missingParent };
